// apps/lc/src/mocks/wireframe/centerAccounts.ts
import type { CenterAccount } from './types'
import { daysAgo } from './dateUtils'

export const CENTER_ACCOUNTS: CenterAccount[] = [
  { id: 'ca-1', role: 'director',  name: '김원장', email: 'director@example.com',  phone: '010-9999-8888', createdAt: daysAgo(200).toISOString(), active: true },
  { id: 'ca-2', role: 'manager',   name: '이실장', email: 'manager@example.com',   phone: '010-9999-7777', createdAt: daysAgo(180).toISOString(), active: true },
  { id: 'ca-3', role: 'teacher',   name: '박교사', email: 'teacher1@example.com',  phone: '010-9999-6666', createdAt: daysAgo(120).toISOString(), active: true },
  { id: 'ca-4', role: 'assistant', name: '정보조', email: 'assistant@example.com', phone: '010-9999-5555', createdAt: daysAgo(45).toISOString(),  active: false },
]
